import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { ChangePasswordPopupModule } from './change-password-popup/change-password-popup.module';
import { ImageCropperPopupComponent } from './image-cropper-popup/image-cropper-popup.component';
import { PrivacyPolicyPopupComponent } from './privacy-policy-popup/privacy-policy-popup.component';
import { TermsAndConditionsPopupComponent } from './terms-and-conditions-popup/terms-and-conditions-popup.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ManifestViewerComponent } from './manifest-viewer/manifest-viewer.component';

@NgModule({
  declarations: [PrivacyPolicyPopupComponent, TermsAndConditionsPopupComponent, ImageCropperPopupComponent, ManifestViewerComponent],
  imports: [
    CommonModule,
    ChangePasswordPopupModule,
    ImageCropperModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [PrivacyPolicyPopupComponent, TermsAndConditionsPopupComponent, ImageCropperPopupComponent],
})
export class PopupsModule {}
